import React from 'react';

const PageHit = ({hit}) => {

  const {
    handle,
    title,
  } = hit;

  const page_url = `/pages/${handle}`;

  return (
    <a href={page_url} className="hit">
      <div className="hit-details">
        <div className="hit-title">{title}</div>
      </div>
    </a>
  );
};

export default PageHit;
